import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import HomePage from '@/views/HomePage.vue';
import PrivacyPolicePage from '@/views/PrivacyPolicePage.vue';
import NewsPage from '@/views/NewsPage.vue';
import FullNewsPage from '@/views/FullNewsPage.vue';
import FaqPage from '@/views/FaqPage.vue';

import JudicialRecoveryPage from '@/views/cases/JudicialRecoveryPage.vue';
import JudicialRecoveryEnterprisePage from '@/views/cases/JudicialRecoveryEnterprisePage.vue';
import BankRuptcyPage from '@/views/cases/BankRuptcyPage.vue';
import BankRuptcyEnterprisePage from '@/views/cases/BankRuptcyEnterprisePage.vue';
import ExtrajudicialRecoveryPage from '@/views/cases/ExtrajudicialRecoveryPage.vue';
import ExtrajudicialRecoveryEnterprisePage from '@/views/cases/ExtrajudicialRecoveryEnterprisePage.vue';

import UserEvents from '@/views/creditor/UserEvents.vue';
import CreateUserEvents from '@/views/creditor/CreateUserEvents.vue';
import CreditorsAssembly from '@/views/creditor/CreditorsAssembly.vue';
import DocumentsTemplates from '@/views/creditor/DocumentsTemplates.vue';
import CasesResume from '@/views/creditor/CasesResume.vue';
import DocumentCenterPage from '@/views/creditor/DocumentCenterPage.vue';
import AccreditationPage from '@/views/creditor/AccreditationPage.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/',
        component: () => import('@/layouts/public/PublicLayout.vue'),
        children: [
            {
                path: '',
                name: 'home',
                component: HomePage
            },
            {
                path: '/categoria/noticias',
                name: 'news',
                component: NewsPage
            },
            {
                path: '/categoria/noticias/:id',
                name: 'full notice',
                component: FullNewsPage
            },
            {
                path: '/recuperacao-judicial',
                name: 'recuperacao judicial empresa',
                component: JudicialRecoveryPage
            },
            {
                path: '/recuperacao-judicial/:id',
                name: 'recuperacao judicial',
                component: JudicialRecoveryEnterprisePage
            },
            {
                path: '/recuperacao-extrajudicial',
                name: 'recuperacao extrajudicial empresa',
                component: ExtrajudicialRecoveryPage
            },
            {
                path: '/recuperacao-extrajudicial/:id',
                name: 'recuperacao extrajudicial',
                component: ExtrajudicialRecoveryEnterprisePage
            },
            {
                path: '/falencia',
                name: 'falencia empresa',
                component: BankRuptcyPage
            },
            {
                path: '/falencia/:id',
                name: 'falencia',
                component: BankRuptcyEnterprisePage
            },

            {
                path: '/leiloes',
                name: 'auctions',
                component: () => import('@/views/AuctionsPage.vue')
            },
            {
                path: '/solicitacao-ppp',
                name: 'ppp-request',
                component: () => import('@/views/forms/PppRequestPage.vue')
            },
            {
                path: '/trabalhe-conosco',
                name: 'careers',
                component: () => import('@/views/forms/CareersPage.vue')
            },
            {
                path: '/denuncia',
                name: 'report',
                component: () => import('@/views/forms/ReportPage.vue')
            },
            {
                path: '/termos-de-uso',
                name: 'terms-of-use',
                component: () => import('@/views/TermsPage.vue')
            },
            {
                path: '/polices-privacy',
                name: 'assembleia-credores',
                component: PrivacyPolicePage
            },
            {
                path: '/central-documento',
                name: 'documents-center',
                component: DocumentCenterPage
            },
            {
                path: '/resumo-geral',
                name: 'cases-resume',
                component: CasesResume
            },
            {
                path: '/assembleia-credores',
                name: 'modelos-documentos',
                component: CreditorsAssembly
            },
            {
                path: '/assembleia-credores/credenciamento',
                name: 'accreditation-page',
                component: AccreditationPage
            },

            {
                path: '/modelos-documentos',
                name: 'polices-pricacy',
                component: DocumentsTemplates
            },

            {
                path: '/habilitacoes-divergencias',
                name: 'UserEvents',
                component: UserEvents
            },
            {
                path: '/habilitacoes-divergencias/novo',
                name: 'CreateUserEvents',
                component: CreateUserEvents
            },
            {
                path: '/duvidas',
                name: 'faq-page',
                component: FaqPage
            },
            {
                path: '/contato',
                name: 'contact-page',
                component: () => import('@/views/ContactPage.vue')
            }
        ]
    }
];

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

export default router;
